"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminQr = void 0;
exports.adminQr = function (axios) {
    return {
        putAdminsOtpConfig: function (request) {
            return axios.put('/admins/otp/config', request.data);
        },
        postAdminsOtpKey: function (request) {
            return axios.post('/admins/otp/key', request.data);
        },
        postAdminsOtpQrCode: function (request) {
            return axios.post('/admins/otp/qrcode', request.data, { responseType: 'blob' });
        },
        postAdminsOtpSecret: function (request) {
            return axios.post('/admins/otp/secret', request.data);
        }
    };
};
